export const store = {
  email: "connect@rise-upp.com",
  phone: "+31 6 87149871",
  phoneHref: "tel:+31687149871",
  freeShippingThreshold: 50,
};

export const images = {
  hero: "https://cdn.magicpatterns.com/patterns/generated-images/87eac4e2-8824-453e-a031-a932b1a7e2be.jpg",
  her: "https://cdn.magicpatterns.com/patterns/generated-images/4e3c5605-b0b4-4415-9441-b245be10e79d.jpg",
  him: "https://cdn.magicpatterns.com/patterns/generated-images/99e91c93-6ffb-4724-a57d-f16d34a0790b.jpg",
  honey: "https://cdn.magicpatterns.com/patterns/generated-images/dfee1b62-aca4-4220-9e8e-134b45927c79.jpg",
  couple: "https://cdn.magicpatterns.com/patterns/generated-images/1fbb2128-1080-4593-b19f-0a9b2ed70412.jpg",
};

export const needFilters = [
  { value: "him", label: "For him" },
  { value: "her", label: "For her" },
  { value: "couples", label: "For couples" },
];
